import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../views/login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: login,
  },{
    path: '/qtindex',
    name: 'qtindex',
    component: () => import('../views/qtindex.vue'),
    children: [
      {
        path: 'qthomepage',
        name: 'qthomepage',
        component: () => import('../views/qthomepage.vue')
      }, {
        path: 'xkfl/:sscope',
        name: 'xkfl',
        component: () => import('../views/xkfl.vue')
      }, {
        path: 'ztfl',
        name: 'ztfl',
        component: () => import('../views/ztfl.vue')
      }, {
        path: 'mrxs/:sscope',
        name: 'mrxs',
        // redirect: 'xkfl',
        redirect: { name: 'xkfl' },
        // component: () => import('../views/mrxs.vue')
      }, {
        path: 'bzxs/:sscope',
        name: 'bzxs',
        redirect: { name: 'xkfl' },
        // redirect: 'xkfl' ,
        // component: () => import('../views/bzxs.vue')
      }, {
        path: 'dyxs/:sscope',
        name: 'dyxs',
        redirect: { name: 'xkfl' },
        // redirect: 'xkfl' ,
        // component: () => import('../views/dyxs.vue')
      }, {
        path: 'shoppingcart',
        name: 'shoppingcart',
        component: () => import('../views/shoppingcart.vue')
      }, {
        path: 'orderlist',
        name: 'orderlist',
        component: () => import('../views/orderlist.vue')
      }, {
        path: 'orderdetail',
        name: 'orderdetail',
        component: () => import('../views/orderdetail.vue')
      }, {
        path: 'deliverylist',
        name: 'deliverylist',
        component: () => import('../views/deliverylist.vue')
      }, {
        path: 'deliverydetail',
        name: 'deliverydetail',
        component: () => import('../views/deliverydetail.vue')
      }, {
        path: 'buyerroom',
        name: 'buyerroom',
        component: () => import('../views/buyerroom.vue')
      }, {
        path: 'ordersubmitok',
        name: 'ordersubmitok',
        component: () => import('../views/ordersubmitok.vue')
      // }, {
      //   path: 'skudetail',
      //   name: 'skudetail',
      //   component: () => import('../views/skudetail.vue')
      }, {
        path: 'changepw',
        name: 'changepw',
        component: () => import('../views/changepw.vue')
      },


    ]

  },
  {
    path: '/htindex',
    name: 'htindex',
    // route level code-splitting
    // this generates a separate chunk (htindex.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "htindex" */ '../views/htindex.vue'),
     children: [
      {
        path: 'yygl',
        name: 'yygl',
        component: () => import('../views/yygl.vue')
      },{
        path: 'khgl',
        name: 'khgl',
        component: () => import('../views/khgl.vue')
      },
    ]
 }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

router.beforeEach((to, from, next) => {
var isAuthenticated = false;

  // var str = window.localStorage.getItem("douttime");
  // var douttimedec = AES.decrypt(str, global.AEScode);
  var douttimedec = window.localStorage.getItem("douttime");
  if (typeof douttimedec == "undefined") {
    // alert("请先登录");
  } else {
    var myDate = new Date();
    if (douttimedec < myDate) {
      // alert("登录超时过期");
    }else{
      isAuthenticated = true;
    }
  }
  console.log("isAuthenticated:"+isAuthenticated);
if (to.name !== 'login' && !isAuthenticated) next({ name: 'login'  })
  else next()
})
